import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import LinkButton from '@/components/link_button/Index.vue';
import ActionButton from '@/components/action_button/Index.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let BaseSetting = class BaseSetting extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, OrangeThemeMixin) {
    tabBuilder() {
        const commonProps = {
            orangeTheme: true,
            flat: true,
            capitalized: true,
            navigator: true,
            exact: true,
        };
        return [
            {
                ...commonProps,
                path: { name: 'payment-preferences' },
                id: 'paymentPreferences',
                label: 'Payment Preferences',
            },
            {
                ...commonProps,
                path: { name: 'saved-payment-methods' },
                id: 'savedPaymentMethods',
                label: 'Saved Payment Methods',
            },
        ];
    }
};
BaseSetting = __decorate([
    Component({
        components: {
            LinkButton,
            ActionButton,
            PageTitle,
        },
    })
], BaseSetting);
export default BaseSetting;
